<template>
    <v-card v-observe-visibility="visibilityChanged">
        <v-toolbar light color="white">
            <v-btn icon @click.native="closeNewContactFunctionDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedContactFunction.id === 0">Add New Contact Function</v-toolbar-title>
            <v-toolbar-title v-else>Edit ContactFunction - {{selectedContactFunction.name}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-layout row v-if="getNetworkError">
            <v-flex xs12>
                <app-alert @dismissed="onDismissedError" :text="getNetworkError.message"></app-alert>
            </v-flex>
        </v-layout>
        <v-tabs
                color="secondary"
                dark
                slider-color="primary"
        >
            <v-tab>Contact Function</v-tab>
            <v-tab-item>
                <v-progress-linear class="top-loading" :active="loading"
                                   :indeterminate="true"></v-progress-linear>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-card dark color="secondary">
                                            <v-card-title>General</v-card-title>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                                v-model="selectedContactFunction.name"
                                                label="Name">
                                        </v-text-field>
                                    </v-flex>

                                </v-layout>

                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-card dark color="secondary">
                                            <v-card-title>Optional Info</v-card-title>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-textarea
                                                lenght
                                                v-model="selectedContactFunction.description"
                                                label="Description"
                                                counter
                                                maxlength="255"
                                        >
                                        </v-textarea>
                                    </v-flex>

                                </v-layout>

                                <v-layout mt-5 row justify-end>
                                    <v-btn :disabled="contactFunctionFormEdited" mt-5 color="secondary" @click.native="saveContactFunction(0)">
                                        Save
                                        <v-icon class="white--text" right>save</v-icon>
                                    </v-btn>
                                </v-layout>

                            </v-flex>

                        </v-layout>


                    </v-container>
                </v-card-text>
            </v-tab-item>

        </v-tabs>

    </v-card>
</template>


<script>
    import {
        Settings,
        ContactFunctionsSettings
    } from '../../store/namespace-helper'

    export default {
      name: 'add-new-contact-function',
      data () {
        return {
          isVisible: false,
          onDismissed: false,
          contactFunctionUpdated: 0
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.contactFunctionUpdated = 0
            } else {
              this.contactFunctionUpdated = 0
            }
          }
        },
        closeNewContactFunctionDialog () {
          this.$store.dispatch(ContactFunctionsSettings.actions.setSelectedContactFunction, null)
          this.$store.dispatch(ContactFunctionsSettings.actions.openCloseNewContactFunctionDialog)
        },
        saveContactFunction (index) {
          this.$store.dispatch(ContactFunctionsSettings.actions.saveContactFunction, this.selectedContactFunction)
          this.contactFunctionUpdated = 0
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        }

      },
      computed: {
        dialog () {
          return this.$store.getters[ContactFunctionsSettings.getters.getOpenNewContactFunctionDialogState]
        },
        selectedContactFunction () {
          console.log('selected contact function: ' + JSON.stringify(this.$store.getters[ContactFunctionsSettings.getters.getSelectedContactFunction]))
          return this.$store.getters[ContactFunctionsSettings.getters.getSelectedContactFunction]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        contactFunctionFormEdited () {
          return this.contactFunctionUpdated < 1
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        }

      },
      watch: {
        selectedContactFunction: {
          handler (val) {
            console.log('selectedContactFunction data changed: ' + JSON.stringify(val))
            this.contactFunctionUpdated++
            console.log('contactFunctionUpdated:' + this.contactFunctionUpdated)
          },
          deep: true
        }
      }
    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .top-loading {
        margin-top: 0px;
    }


</style>


// WEBPACK FOOTER //
// src/components/Shared/AddContactFunction.vue